import Constants from 'api-constants'
import { uniqBy } from 'lodash'
import { resolveBookmarkType } from '../helpers'

/**
 * Transform get user bookmarks response to object
 *
 * Note: sortingPosition for bookmarks added as a backend return bookmarks with modified date descending sorting.
 * Nagra backend returns modifiedDate property for all bookmarks, but some backends not (Huawei) so there was a
 * decision to add index for saving positioning and to be generic
 *
 * @param {Array<BookmarkNagraResponse>} bookmarks - an array of bookmarks from get bookmarks Nagra response
 * @returns {Object}
 */
export const continueWatchingDataFactory = (bookmarks = []) => {
    if (!bookmarks.length) return { programs: [], catchups: [] }

    const continueWatching = uniqBy(bookmarks, 'contentId').reduce(
        (acc, bookmark, index) => {
            const { contentId, position, contentType } = bookmark
            const bookmarkType = resolveBookmarkType(contentType)

            if (bookmarkType === Constants.programType.live) {
                acc.catchups.push({ id: contentId, position, sortingPosition: index })
            } else {
                acc.programs.push({ id: contentId, position, sortingPosition: index })
            }
            return acc
        },
        {
            programs: [],
            catchups: [],
        }
    )

    return continueWatching
}

/**
 * Schema of nagra get bookmarks response object
 * @typedef {Object} BookmarkNagraResponse
 * @property {String} account - account id
 * @property {String} userId - user id
 * @property {String} deviceId - device id
 * @property {String} contentId - content id
 * @property {String} contentType - content type
 * @property {String} position - bookmark position
 * @property {Date} creationDate - creation date
 * @property {Date} modifiedDate - modified date
 * @property {Object} metadata - additional bookmark data
 * @property {Array} tags - additional tags
 */
